import styled from "styled-components";
import Layout from "../Layout/Layout";
import { Helmet } from "react-helmet";

const IFrame = styled.iframe`
  border: none;
  width: 100%;
  height: calc(100vh + 85px);
  margin-top: -90px;
`;

const ComplaintSystem = () => {
  return (
    <Layout authRequired={false} hideFooter={true}>
      <Helmet>
        <title>
          Whistleblower- / Hinweisgeberschutz gem. Hinweisgeberschutzgesetz
          (HinSchG)
        </title>
        <meta
          name="description"
          content="Meldesystem für Hinweisgeber/Whistleblower."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Berliner Glasfaserkabel GmbH" />
        <meta httpEquiv="content-language" content="de" />
      </Helmet>
      <IFrame src="https://www.bayka.de/unternehmen/beschwerdesystem/" />
    </Layout>
  );
};
export default ComplaintSystem;
